import { CloseIcon } from 'components/icons/CloseIcon';
import { TickIcon } from 'components/icons/TickIcon';

interface IBackgroundUpload {
  onCancel: () => void;
  onSave?: () => void;
  type: string;
  currentResolution?: string;
  expectedResolution?: string;
  details?: any;
  success?: boolean;
}

export default function BackgroundUpload({
  onCancel,
  onSave,
  type,
  currentResolution,
  expectedResolution,
  details,
  success
}: IBackgroundUpload) {
  return (
    <div className="transparent font-lato">
      <div className="relative border-x border-t bg-gray-bg-dark border-gray-300  bg-white pb-7 pt-9 px-7 w-screen md:w-[520px] md:min-h-[100px] rounded-t-lg">
        <div className="flex mb-5 items-center">
          {type === 'Upload' && (
            <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">
              {currentResolution !== expectedResolution ? 'Background image not uploaded' : 'Background image uploaded'}
            </span>
          )}
          {type === 'Update' && (
            <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">
              {success ? 'Background image updated' : 'Background image not updated'}
            </span>
          )}
          {type === 'Upload' && (
            <div className="bg-red-main rounded-full ml-2 w-5 h-5 flex items-center justify-center">
              {currentResolution !== expectedResolution ? (
                <CloseIcon className="fill-white w-4 h-4" color="white" />
              ) : (
                <TickIcon className="fill-white w-3 h-4" />
              )}
            </div>
          )}
          {type === 'Update' && (
            <div className="bg-red-main rounded-full ml-2 w-5 h-5 flex items-center justify-center">
              {success ? (
                <TickIcon className="fill-white w-3 h-4" />
              ) : (
                <CloseIcon className="fill-white w-4 h-4" color="white" />
              )}
            </div>
          )}
        </div>
        {type === 'Upload' ? (
          <p>
            {currentResolution !== expectedResolution
              ? `The background image must have a resolution of ${expectedResolution}. The image you uploaded has a resolution of ${currentResolution}`
              : ''}
          </p>
        ) : type === 'Update' && success ? (
          <p>
            {details?.status === 'pending'
              ? 'Background image was updated.'
              : 'Background image was updated and video is being processed.'}
          </p>
        ) : (
          <p>
            {details?.status === 'started'
              ? `The background image cannot be updated while the video is being ${
                  details.status_type === 'processing' ? 'processed' : 'edited'
                }.`
              : 'The background image cannot be updated since the video could not be processed.'}
          </p>
        )}
      </div>
      <div className="flex text-[13px] pb-6 px-4 bg-white rounded-b-lg border-x">
        <button
          className="bg-red-main py-3 px-12 text-white rounded-[10px] ml-auto"
          onClick={() => {
            if (onSave) {
              onSave();
            }
            onCancel();
          }}
        >
          OK
        </button>
      </div>
    </div>
  );
}
